// Global Variables (MANDATORY)
export const appId = typeof __app_id !== 'undefined' ? __app_id : 'default-app-id';
export const initialAuthToken = typeof __initial_auth_token !== 'undefined' ? __initial_auth_token : null;

// Supabase Configuration
// Supports both REACT_APP_ prefix (required for CRA) and non-prefixed (for consistency)
export const supabaseConfig = {
  url: process.env.REACT_APP_SUPABASE_URL || process.env.SUPABASE_URL || '',
  anonKey: process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.SUPABASE_ANON_KEY || '',
};

// Mock Web App Data
export const MOCK_WEB_APPS = [
  { 
    name: "Health Tracking App", 
    description: "Track your diet, nutrition, and health metrics with comprehensive analytics.", 
    icon: "Code", 
    url: "/diet-app/" 
  },
  { 
    name: "Daily Habit Tracker", 
    description: "A minimalist application to log and visualize daily goals and progress.", 
    icon: "LayoutGrid", 
    url: "#" 
  },
  { 
    name: "3D Portfolio Viewer", 
    description: "Interactive 3D visualization built with Three.js to display project models.", 
    icon: "Rocket", 
    url: "#" 
  },
  { 
    name: "Markdown Converter Tool", 
    description: "Convert complex Markdown files to HTML, PDF, or custom formats.", 
    icon: "ExternalLink", 
    url: "#" 
  },
];

// Mock Journal Entry Data
export const MOCK_BLOG_POSTS_RAW = [
  {
    id: 'mock1',
    title: 'The Future of Single-File Web Apps',
    summary: 'Exploring the capabilities and constraints of building modern, complex applications entirely within a single JSX or HTML file.',
    content: 'Single-file applications offer incredible portability and simplicity for rapid prototyping and deployment. By leveraging modern React features, hooks, and external libraries like Tailwind CSS (which is assumed here), we can create responsive, feature-rich tools without the boilerplate of multi-file projects.\n\nThe key to this architecture is careful state management and component composition, ensuring that performance remains high even as complexity grows. This approach is particularly effective in collaborative environments like the one we are using.',
    date: new Date(Date.now() - 86400000 * 3).toISOString(),
    updated_at: new Date().toISOString(),
    tags: ['React', 'Deployment', 'Architecture'],
    doc_type: 'living',
    changelog: [
      { date: new Date().toISOString().slice(0, 10), note: 'Added section on context management approach' },
      { date: new Date(Date.now() - 86400000).toISOString().slice(0, 10), note: 'Initial publish' },
    ],
    authorId: 'admin-mock-id',
  },
  {
    id: 'mock2',
    title: 'Why Firestore is a Game-Changer for Prototypes',
    summary: 'A look at how Firestore\'s real-time features and flexible schema speed up the development cycle.',
    content: 'The real-time data synchronization provided by Firestore is ideal for quick prototypes and multi-user collaboration tools. Its `onSnapshot` listener simplifies data fetching and instantly updates the UI without complex polling mechanisms. This drastically reduces the time needed to build reactive interfaces.',
    date: new Date(Date.now() - 86400000 * 7).toISOString(),
    updated_at: new Date(Date.now() - 86400000 * 7).toISOString(),
    tags: ['Firebase', 'Data', 'NoSQL'],
    doc_type: 'post',
    changelog: [],
    authorId: 'admin-mock-id',
  }
];

export const DOC_TYPES = {
  POST: 'post',
  LIVING: 'living',
};

// Table names for Supabase
export const TABLE_NAMES = {
  BLOG_POSTS: 'blog_posts',
  BLOG_COMMENTS: 'blog_comments',
  // Note: Using existing 'users' and 'token_balances' tables from health app
};
